/* unplugin-vue-components disabled */import script from "./PaidAddModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaidAddModal.vue?vue&type=script&setup=true&lang=ts"

import "./PaidAddModal.vue?vue&type=style&index=0&id=1ffe3324&scoped=true&lang=less"
import "./PaidAddModal.vue?vue&type=style&index=1&id=1ffe3324&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ffe3324"]])

export default __exports__